import React, { useContext } from 'react';
import './Team.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { LanguageContext } from '../../context/LanguageContext';
import imgOne from '../../assets/newmonaassets/image_samet_dentist.jpg';
import imgTwo from '../../assets/newmonaassets/image_ecem_dentist.jpg';
import imgThree from '../../assets/newmonaassets/image_eylül_dentist.jpg';
import imgFour from '../../assets/newmonaassets/image_gizem_dentist.jpg';

const Team = () => {
    const { t } = useContext(LanguageContext);

    const doctorImages = {
        0: imgOne,    // Samet Aksu
        1: imgTwo,    // Ennur Ecem Aydın
        2: imgThree,  // Eylül Karasoy
        3: imgFour    // Gizem Kiraz
    };

    return (
        <section className='team-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SectionTitle 
                            subTitle={t('team.sectionTitle')}
                            title={t('team.title')}
                        />
                    </div>

                    <div className="col-lg-6">
                        <p className='team-description'>{t('team.sideDescription')}</p>
                    </div>
                </div>

                <div className="row">
                    {t('team.doctors').map((doctor, index) => (
                        <div key={index} className="col-lg-3 col-sm-6">
                            <div className="team-card">
                                <div className="team-img">
                                    <img src={doctorImages[index]} alt={doctor.name} />
                                </div>
                                <div className="team-text">
                                    <h3>{doctor.name}</h3>
                                    <p>{doctor.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;